import { useEffect } from "react";
import { cn } from "@/lib/cn";

export type ToastPayload = { message: string; kind?: "ok" | "err" };

export function ToastBanner({
  toast,
  onDismiss,
}: {
  toast: ToastPayload | null;
  onDismiss: () => void;
}) {
  useEffect(() => {
    if (!toast) return;
    const id = window.setTimeout(onDismiss, 4200);
    return () => window.clearTimeout(id);
  }, [toast, onDismiss]);

  if (!toast) return null;

  return (
    <div
      role="status"
      className={cn(
        "pointer-events-auto fixed bottom-6 left-1/2 z-[90] max-w-[min(560px,calc(100vw-2rem))] -translate-x-1/2 rounded-xl border px-4 py-3 text-sm shadow-lg",
        toast.kind === "err"
          ? "border-[rgba(255,59,48,0.35)] bg-[var(--color-danger-bg)] text-[var(--color-danger)]"
          : "border-[var(--color-border)] bg-[var(--color-surface)] text-[var(--color-text)]",
      )}
      style={{ boxShadow: "var(--shadow-modal, 0 12px 40px rgba(0,0,0,0.15))" }}
    >
      <div className="flex items-start justify-between gap-3">
        <p className="min-w-0 flex-1 leading-snug">{toast.message}</p>
        <button
          type="button"
          onClick={onDismiss}
          className="shrink-0 rounded-md px-2 py-0.5 text-[11px] font-medium text-[var(--color-text-muted)] hover:bg-[var(--color-surface-3)]"
        >
          Dismiss
        </button>
      </div>
    </div>
  );
}
